import Information from "@/components/Information";
import newsDetail from "@/components/information/NewsDetail";
import CommonQuestion from "@/components/commonQuestion/CommonQuestion";



// router.beforeEach((to, from, next) => {
//     // keepAlive 缓存页面滚动条位置记录
//      if (from.meta.keepAlive) {
//        from.meta.historyScorllY = window.scrollY
//      }
//      // keepAlive 缓存处理
//      if (to.name !== from.name && to.meta.keepAlive) {
//        // 判断目标路径和历史路径是否相同
//        if (to.meta.lastHistoryFullPath && to.meta.lastHistoryFullPath === to.fullPath || !to.meta.lastHistoryFullPath) {
//          // 相同则读取缓存数据
//          to.meta.keepAliveChange = false
//        } else if (to.meta.lastHistoryFullPath && to.meta.lastHistoryFullPath !== to.fullPath) {
//          // 不同则重载
//          to.meta.keepAliveChange = true
//        }
//      }
//    })
//    router.beforeResolve((to, from, next) => {
//        if (to.meta.historyScorllY && !to.meta.keepAliveChange) {
//        setTimeout(function () {
//          window.scrollTo(0, to.meta.historyScorllY)
//        }, 100);
//      }
//      next()
//    })

export default [{
    path: "/studyInfo/industry/:id" + ".html",
    name: "CommonQuestion",
    component: CommonQuestion,
}, {
    path: "/studyInfo/basis/:id" + ".html",
    name: "CommonQuestion2",
    component: CommonQuestion,
}, {
    path: "/studyInfo/improve/:id" + ".html",
    name: "CommonQuestion3",
    component: CommonQuestion,
}, {
    path: "/CommonQuestion/:id" + ".html",
    name: "CommonQuestion4",
    component: CommonQuestion,
}, {
    path: "/xinwen.html",
    name: "Information",
    component: Information,
    meta: {
        title: '公司新闻_资讯中心_51Testing软件测试培训网',
    },
}, {
    path: "/hezuo.html",
    name: "Information2",
    component: Information,
    meta: {
        title: '合作动态_资讯中心_51Testing软件测试培训网',
    },
}, {
    path: "/huodong.html",
    name: "Information3",
    component: Information,
    meta: {
        title: '班级活动_资讯中心_51Testing软件测试培训网',
    },
}, {
    path: "/xinde.html",
    name: "Information4",
    component: Information,
    meta: {
        title: '学员心得_资讯中心_51Testing软件测试培训网',
    },
}, {
    path: "/videoList.html",
    name: "Information5",
    component: Information,
    meta: {
        // keepAlive: true,
        title: '视频广场_资讯中心_51Testing软件测试培训网',
    },
}, {
    path: "/newsIndexDetail/:id" + '.html',
    name: "NewsDetail",
    component: newsDetail,
    props: true
        // meta: { keepAlive: true }
}, {
    path: "/newsIndex/company/:id" + '.html',
    name: "NewsDetail2",
    component: newsDetail,
    props: true
        // meta: { keepAlive: true }
}, {
    path: "/newsIndex/:id" + '.html',
    name: "NewsDetail3",
    component: newsDetail,
    props: true
        // meta: { keepAlive: true }
}, {
    path: "/newsIndex/speech/:id" + '.html',
    name: "NewsDetail4",
    component: newsDetail,
    props: true
        // meta: { keepAlive: true }
}, {
    path: "/newsIndex/activity/:id" + '.html',
    name: "NewsDetail5",
    component: newsDetail,
    props: true
        // meta: { keepAlive: true }
}, ]


// WEBPACK FOOTER //
// ./src/router/news.js